















import { Component, Vue } from "vue-property-decorator";
import Page from "@/components/for-page-grid/Page.vue";
import XButton from "@/components/SimpleButton.vue";

@Component({
  components: { Page, XButton },
})
class PaymentsNoAuthProcess extends Vue {
  getText() {
    return 'Платеж в обработке';
  }
  redirect() {
    this.$router.push({ name: "auth" });
  }
}

export default PaymentsNoAuthProcess;
